import { Injectable } from '@angular/core';
import { FormGroup, NgForm } from '@angular/forms';
import { ActivatedRoute, NavigationEnd, Params, Router } from '@angular/router';
import { NgProgressRef } from 'ngx-progressbar';
import { Observable, Subject, Subscription } from 'rxjs';
import { AuthLogin, AuthToken, Res } from '../models';
import { ApiService } from './api.service';

@Injectable({
  providedIn: 'root'
})
export class AuthService {

  isLoggedInSubject: Subject<boolean> = new Subject<boolean>();
  isEmailSubject: Subject<boolean> = new Subject<boolean>();
  loginCheckErrorSubject: Subject<string> = new Subject<string>();
  tokenExpirationCheckInterval: any; //NodeJS.Timeout;
  invitationTicket: string = null;

  openUrls: string[] = [
    '/',
    '/login',
    '/registration'
  ]

  constructor(
    private api: ApiService,
    private router: Router,
    private currentRoute: ActivatedRoute,
  ) {

    this.startCheckingTokenExpiration();
  }

  /**
   * 
   * @param params 
   * @param progressRef 
   */
  login(params: AuthLogin, progressRef: NgProgressRef, form: NgForm): void {

    progressRef.start();

    let subscription: Subscription = this.api.post('login', params, 'auth').subscribe((response: Res) => {

      if (response != null) {

        form.resetForm();
        this.setToken(response.result);
        this.isLoggedInSubject.next(this.isLoggedIn());

        this.router.navigateByUrl('/products');
      }

      progressRef.complete();
      subscription.unsubscribe();
    },
      error => {
        progressRef.complete();
        subscription.unsubscribe();
      });
  }


  /**
   * 
   * @param progressRef 
   */
  logout(progressRef: NgProgressRef): void {

    progressRef.start();

    let subscription: Subscription = this.api.post('logout', null, 'auth').subscribe((response: Res) => {

      window.location.href = '/login';

      this.deleteToken();
      this.isLoggedInSubject.next(this.isLoggedIn());

      progressRef.complete();
      subscription.unsubscribe();
    },
      error => {
        progressRef.complete();
        subscription.unsubscribe();
      });
  }


  /**
   * 
   * @param params 
   * @param progressRef 
   * @param form 
   */
  registration(params: any, progressRef: NgProgressRef, form: NgForm): void {

    progressRef.start();

    let subscription: Subscription = this.api.post('registration', params).subscribe((response: Res) => {
      console.log('[RESPONSE] registration: ', response);

      if (response != null) {

        form.reset();
        // , {queryParams: this.currentRoute.snapshot.queryParams.invitationTicket}
        this.router.navigate(['/login']);
      }

      progressRef.complete();
      subscription.unsubscribe();
    },
      error => {
        progressRef.complete();
        subscription.unsubscribe();
      });
  }


  /**
   * 
   * @param params 
   * @param progressRef 
   */
  checkEmail(params: any, progressRef: NgProgressRef) {

    let subscription: Subscription = this.api.post('checkEmail', params).subscribe((response: Res) => { console.log("CHECK EMAIL: ", response);
    

      subscription.unsubscribe();
    },

      error => {
        subscription.unsubscribe();
      });
  }

  /**
   * 
   * @param params 
   * @param progressRef 
   */
  resetPass(params: any, progressRef: NgProgressRef) {

    let subscription: Subscription = this.api.post('forgot_password', params).subscribe((response: Res) => {

      subscription.unsubscribe();
    },

      error => {
        subscription.unsubscribe();
      });
  }


  /**
  *
  * @param params  
  * @param progressRef 
  */
  checkRegistrationCode(params: any): void {


    let subscription: Subscription = this.api.post('verifyEmail', params).subscribe((response: Res) => {
      console.log("CHECK CODE: ", response);

      if (response != null) {

        this.isEmailSubject.next(response.result);

      }

      subscription.unsubscribe();
    },
      error => {
        subscription.unsubscribe();
      });
  }


  /**
   * 
   */
  refreshToken(): void {

    let subscriptions: Subscription = this.api.post('refresh', '', 'auth').subscribe((response: Res) => {

      if (response != null) {

        console.log('REFRESH JWT TOKEN');

        this.setToken(response.result);
        this.isLoggedInSubject.next(this.isLoggedIn());
      }

      subscriptions.unsubscribe();
    });
  }


  /**
   * 
   */
  isLoggedIn(): boolean {

    let response: AuthToken = this.getToken();
    return response.access_token != null ? true : false;
  }

  /**
   * 
   * @returns 
   */
  listenerIsEmailCheck(): Observable<boolean> {

    return this.isEmailSubject.asObservable();
  }

  /**
   * 
   */
  listenerIsLoggedIn(): Observable<boolean> {

    return this.isLoggedInSubject.asObservable();
  }

  /**
   * 
   * @param data 
   */
  setErrorMessage(data: any): void {

    this.loginCheckErrorSubject.next(data);
  }

  /**
   * 
   * @returns 
   */
  listenerErrorMessageError(): Observable<string> {

    return this.loginCheckErrorSubject.asObservable();
  }

  /**
   * Проверка страниц доступных только если пользователь не авторизован
   * Если пользователь авторизован и идет на "открытые" страницы, то перенапрвляем его на главную закрытую страницу
   * 
   * @param event 
   */
  checkingOpenPages(event: NavigationEnd): void {

    let queryParams: Params = this.currentRoute.snapshot.queryParams;

    if (queryParams.hasOwnProperty('invitationTicket')) {
      console.log('queryParams', queryParams)

      localStorage.setItem('invitation_ticket', queryParams.invitationTicket);
      //this.invitationTicket = queryParams.invitationTicket;
    }

    let url = event.url.split('?'); // отсекаем query параметры

    if (this.openUrls.includes(url[0])) {

      if (this.isLoggedIn()) {

        //this.router.navigate(['/products']);
        this.router.navigateByUrl('/products');
      }
    }

    if (this.isLoggedIn()) {

      // запустить активацию
      this.acceptInvitation();
    }
  }


  /**
   * 
   */
  acceptInvitation(): void {

    let invitationTicket = localStorage.getItem('invitation_ticket');

    if (invitationTicket != null) {

      let subscriptions: Subscription =
        this.api.get('acceptInvitation?invitationTicket=' + invitationTicket, '', 'private').subscribe((response: Res) => {
          console.log('[RESPONSE] acceptInvitation: ', response);

          localStorage.removeItem('invitation_ticket');
          subscriptions.unsubscribe();
        },
          error => {
            subscriptions.unsubscribe();
            localStorage.removeItem('invitation_ticket');
          }
        );
    }
  }


  /**
   * 
   */
  startCheckingTokenExpiration(): void {

    let data: AuthToken = this.getToken();

    if (data.expires_in) {
      console.log('[START] startCheckingTokenExpiration');

      let time: number = (data.token_installation_time + data.expires_in) - new Date().getTime();

      setTimeout(() => { this.refreshToken(); }, time);
    }
  }


  /**
   * 
   */
  checkingTokenExpiration(): void {

    let data: AuthToken = this.getToken();

    if (data.expires_in > 0) {
      console.log('checkingTokenExpiration');

      let interval = setInterval(() => {

        this.refreshToken();

        clearInterval(interval);

      }, data.expires_in);
    }
  }


  /**
   * 
   */
  getToken(): AuthToken {

    return {
      access_token: localStorage.getItem('access_token'),
      expires_in: +localStorage.getItem('expires_in'),
      refresh_expires_in: +localStorage.getItem('refresh_expires_in'),
      refresh_token: localStorage.getItem('refresh_token'),
      token_type: localStorage.getItem('token_type'),

      token_installation_time: +localStorage.getItem('token_installation_time'),
      token_installation_time_full: new Date(localStorage.getItem('token_installation_time_full'))
    }
  }


  /**
   * 
   * @param data 
   */
  setToken(data: AuthToken): void {

    localStorage.setItem('access_token', data.access_token);
    localStorage.setItem('expires_in', data.expires_in + '');
    localStorage.setItem('refresh_expires_in', data.refresh_expires_in + '');
    localStorage.setItem('refresh_token', data.refresh_token);
    localStorage.setItem('token_type', data.token_type);

    localStorage.setItem('token_installation_time', String(new Date().getTime()));
    localStorage.setItem('token_installation_time_full', String(new Date()));

    console.log('[SET TOKEN] Time: ', new Date());

    this.checkingTokenExpiration();

    //this.isLoggedInSubject.next(this.isLoggedIn());
  }


  /**
   * 
   */
  deleteToken(): void {

    localStorage.removeItem('access_token');
    localStorage.removeItem('expires_in');
    localStorage.removeItem('refresh_expires_in');
    localStorage.removeItem('refresh_token');
    localStorage.removeItem('token_type');

    localStorage.removeItem('token_installation_time');
    localStorage.removeItem('token_installation_time_full');

    //this.isLoggedInSubject.next(this.isLoggedIn());
  }

  /**
  *
  */
  onConfirm(params: any): Observable<Res> {

    return this.api.post('file', params);

  }
}
